import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  label?: string;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  message: string;
}

// Catches render-time exceptions in chart panels so a corrupt API payload or
// ECharts series mismatch can't bring down the whole dashboard.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message || 'Onbekende fout' };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', this.props.label ?? '(unlabeled)', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return (
      <div style={{
        padding: 12, fontSize: 12, color: '#b91c1c',
        background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6,
      }}>
        Onderdeel kon niet worden geladen{this.props.label ? ` (${this.props.label})` : ''}: {this.state.message}
      </div>
    );
  }
}
